/**
 * Read the visible web composer textarea when React state is behind the DOM.
 * Automation, some IMEs, and password-manager fills set <textarea>.value
 * without going through MentionsInput onChange — Send then sees an empty
 * store and no-ops (or a re-render wipes the box).
 */

const COMPOSER_PLACEHOLDER_RE = /Give Work a goal|Send a follow-up|Ask for changes|Ask a question, search the web/i;

export function readComposerDomText(node) {
  if (!node) return '';
  if (typeof node.value === 'string' && /^(TEXTAREA|INPUT)$/i.test(node.tagName || '')) {
    return node.value;
  }
  const textarea = typeof node.querySelector === 'function'
    ? node.querySelector('textarea')
    : null;
  return textarea && typeof textarea.value === 'string' ? textarea.value : '';
}

function isVisibleComposerNode(el) {
  if (!el || typeof el.getBoundingClientRect !== 'function') return false;
  const box = el.getBoundingClientRect();
  return box.width > 10 && box.height > 10;
}

export function readWebComposerDomText(doc = typeof document !== 'undefined' ? document : null, root = null) {
  if (!doc) return '';
  // Deck mounts several live composers. A scoped read must never fall back
  // to another column, a resource search field, or a document editor.
  if (root) return String(root.querySelector('textarea[data-gab-composer]')?.value || '');
  const nodes = Array.from(doc.querySelectorAll('textarea'));
  const matches = nodes.filter((el) => {
    const label = [
      el.getAttribute('placeholder'),
      el.getAttribute('aria-label'),
    ].filter(Boolean).join(' ');
    return COMPOSER_PLACEHOLDER_RE.test(label);
  });
  // Frozen /c/:id screens leave 0×0 composers in the DOM. Prefer the live box
  // so Send does not read an empty leftover and no-op.
  const visible = matches.find(isVisibleComposerNode) || matches.find((el) => String(el.value || '').trim());
  if (visible) return String(visible.value || '');
  const active = doc.activeElement;
  if (active && /^(TEXTAREA|INPUT)$/i.test(active.tagName || '') && isVisibleComposerNode(active)) {
    return String(active.value || '');
  }
  return '';
}
